import React, { useState } from "react";
import FormCapaianSS from "./FormCapaianSS";
import { FORM_TYPE } from "../../../Constant/FormType";

const BuatCapaianSS = () => {

  const [formCapaianSS, setFormCapaianSS] = useState({
    entitas: "",
    perspektif: "",
    kode_ss: "",
    nama_ss: "",
    bobot_sasaran_strategis: "",
    capaian_tw_1: "",
    capaian_tw_2: "",
    capaian_tw_3: "",
    capaian_tw_4: "",
    capaian_normalisasi_tw_1: "",
    capaian_normalisasi_tw_2: "",
    capaian_normalisasi_tw_3: "",
    capaian_normalisasi_tw_4: "",
    nilai_sasaran_strategis_tw_1: "",
    nilai_sasaran_strategis_tw_2: "",
    nilai_sasaran_strategis_tw_3: "",
    nilai_sasaran_strategis_tw_4: "",
    nilai_sasaran_strategis_normalisasi_tw_1: "",
    nilai_sasaran_strategis_normalisasi_tw_2: "",
    nilai_sasaran_strategis_normalisasi_tw_3: "",
    nilai_sasaran_strategis_normalisasi_tw_4: "",
    anggaran: "",
    komitmen: "",
    aktual: "",
    sisa_anggaran: ""
  })

  return (
    <FormCapaianSS
      formCapaianSS={formCapaianSS}
      setFormCapaianSS={setFormCapaianSS}
      formType={FORM_TYPE.Create}
    />
  )
}

export default BuatCapaianSS;